import React from 'react';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  VisitNoteServiceCode,
} from 'views/EMR/components/ServiceLookup/type';
import EditableNumberField from 'views/EMR/components/EditableNumberField';

export default {
  id: 'externalUsedQuantity',
  accessorKey: 'serviceCodeDetails.externalUsedQuantity',
  header: 'Already Used',
  size: 160,
  minSize: 100,
  multiLineHeader: true,
  meta: {
    editable: {
      Component: EditableNumberField,
      props: { maskExtension: { min: 0 } },
      alwaysEditable: true,
    },
  },
  cell: ({ row }) => (
    <div className="flex gap-2 flex-wrap">
      <div className="flex justify-between p-2 border border-gray-200 bg-gray-100 text-xs rounded w-12">
        {row.original.serviceCodeDetails?.externalUsedQuantity ?? ''}
      </div>
    </div>
  ),
} as ColumnDef<VisitNoteServiceCode>;
